import gql from 'graphql-tag'

export const RECORD_MEETING_ATTENDANCE = gql`
  mutation recordZoomAttendance($zoomId: String!, $attending: Boolean!) {
    recordZoomAttendance(zoomId: $zoomId, attending: $attending)
  }
`
